export const meta = {
  id: 'A09',
  slug: 'fazer-um-treinamento',
  title: 'Como fazer um Treinamento',
  description: 'Navegue por módulos e aulas, acompanhe o progresso e continue seu aprendizado.',
  profile: 'student',
  category: 'treinamentos',
  type: 'flow',
  status: 'published',
  order: 130,
  keywords: ['treinamento', 'curso', 'módulos', 'aulas', 'conteúdo', 'progresso'],
  previous: 'A07',
  next: 'A10',
  related: ['A10', 'A05', 'A06'],
  updatedAt: '2026-08-17',
  appVersion: 'v1'
}

# Como fazer um Treinamento

Um Treinamento organiza o aprendizado em **Módulos → Aulas**. Você avança pelas aulas e registra a conclusão conforme consome o conteúdo disponível.

<Diagram kind="training-structure" caption="O Treinamento organiza o aprendizado: o programa é dividido em Módulos, e cada Módulo reúne Aulas." />

## Como avançar

<Steps>
  <Step title="Abra o Treinamento">
    Consulte os módulos, aulas e seu progresso atual.
  </Step>
  <Step title="Entre na aula disponível">
    Use a navegação de conteúdo para acessar a aula atual ou continuar de onde parou.
  </Step>
  <Step title="Consuma o conteúdo e os recursos">
    A aula pode apresentar vídeo, texto, links, arquivos ou outros recursos disponíveis.
  </Step>
  <Step title="Conclua a aula">
    Use a ação de conclusão quando estiver disponível e siga para a próxima aula.
  </Step>
</Steps>

<HelpImage alt="Treinamento com módulos, aulas e indicador de progresso" pendingId="A09.2" />

<Callout type="important">
  A conclusão das aulas alimenta o progresso real do Treinamento. Quando o Treinamento fizer parte de uma Formação, esse progresso também pode refletir no componente correspondente.
</Callout>
